import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import * as auth from "../../store/ducks/auth.duck";
import * as config from "../../store/ducks/config.duck";
import CustomInput from "../../components/CustomInput";
import styles from "../../../styles/Login.module.css";
import { createFormikValidation } from "../../utils/Utils";
import { Link } from "react-router-dom";
import { login } from "../../crud/auth.crud";
import * as utils from "../../../_metronic/utils/utils";
import { useAlert } from "../../context/AlertContext";

function Login(props) {
    const [submitting, setSubmitting] = useState(false);

    const { showAlert } = useAlert();

    const getInitialValues = () => {
        return {
            usuario: "",
            password: "",
        };
    };

    const validate = (values) => {
        const map = new Map();

        map.set("usuario", "e-mail/CPF/CNPJ");
        map.set("password", "senha");

        const errors = createFormikValidation(map, values);

        return errors;
    };

    const onSubmit = (values) => {
        setSubmitting(true);

        login(values)
            .then((res) => {
                if (res.data.reativar_acesso) {
                    props.history.push(`/reativar-acesso`, { id: res.data.id, ...values });

                    return;
                }
                if (res.data.primeiro_acesso) {
                    props.history.push(`/primeiro-acesso?usuario=${values.usuario}`);

                    return;
                }

                utils.setStorage("authToken", res.data.token, null);

                props.login(res.data);
                props.requestPhone();
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={styles.containerForm}>
                        <p className={styles.welcomeText}>Seja bem-vindo(a)!</p>

                        <p className={styles.textoComplementar}>
                            Insira suas credencias abaixo e acesse sua conta <small className={styles.textoDestaque}>Sur.IA</small>
                        </p>

                        <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    <div style={{ flex: 1 }}>
                                        <div className={styles.formLogin}>
                                            <CustomInput placeholder="Insira seu e-mail ou CPF/CNPJ" required label="E-mail ou CPF/CNPJ" name="usuario" value={values.usuario} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} />

                                            <CustomInput placeholder="Digite sua senha" required label="Senha" name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} tipoInputRight="password" />
                                        </div>

                                        <div className="d-flex justify-content-between flex-column flex-sm-row">
                                            <p className={styles.linkEsqueciSenha}>
                                                <a href="/privacidade" className={styles.termosDeUso}>
                                                    Privacidade
                                                </a>
                                                &nbsp;e&nbsp; 
                                                <a href="/termos-de-uso" className={styles.termosDeUso}>
                                                    Termos de Uso
                                                </a>
                                            </p>
                                            <Link to="/esqueceu-senha" className={styles.linkEsqueciSenha}>
                                                Esqueceu sua senha?
                                            </Link>
                                        </div>

                                    </div>

                                    <div>
                                        <button type="submit" className={styles.buttonLogin} disabled={submitting}>
                                            {!submitting ? "Entrar" : <div className="icon-loading" />}
                                        </button>

                                        <p className={styles.textoCadastro}>
                                            Novo por aqui?{" "}
                                            <Link to="/signin" style={{ color: "#00571E" }}>
                                                Cadastre-se.
                                            </Link>
                                        </p>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
}

export default connect(null, {...auth.actions, ...config.actions})(Login);
